import { Hourglass, ExternalLink } from "lucide-react";

export const DEFAULT_SOURCE = "https://www.stars4peace.org/origins.html";

// Public placeholder for media we could not carry over yet; links to the original.
const ComingSoon = ({ cfg, kind = "content", children }) => {
  const link = cfg.source_link === undefined ? DEFAULT_SOURCE : cfg.source_link;
  const label = cfg.source_label || "See it on the original page at stars4peace.org";
  return (
    <div className="max-w-3xl rounded-2xl border border-[#E2E0DC] bg-white/80 p-6 shadow-sm" data-testid="media-coming-soon">
      <div className="flex items-start gap-4">
        <span className="h-11 w-11 rounded-xl bg-[#B8860B]/15 text-[#B8860B] flex items-center justify-center shrink-0"><Hourglass className="h-5 w-5" /></span>
        <div className="flex-1">
          <p className="font-extrabold text-[#1A1A1A]">Content coming soon</p>
          <p className="text-sm text-[#5C5C5C] mt-1">{cfg.coming_soon_note || `This ${kind} is being added to THE WALL. Until then, you can find it on the original page.`}</p>
          {link && <a href={link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 mt-3 text-sm font-semibold text-[#B8860B] underline underline-offset-2" data-testid="coming-soon-source-link">{label} <ExternalLink className="h-3.5 w-3.5" /></a>}
          {children && <div className="mt-4 pt-4 border-t border-dashed border-[#E2E0DC]">{children}</div>}
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
